// extracted by mini-css-extract-plugin
export var locationCard = "_fl-0";